import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Divider,
  Typography,
  Box,
  Grid,
  Stack,
  Card,
  CardHeader,
  CardContent,
  Button
} from '@mui/material';

export default function BuyListing(props) {

  const [renovationType, setRenovationType] = React.useState('');
  const [renovationCost, setRenovationCost] = React.useState('');

  return (
    <Box>
      {/* Main Container */}
      <Box sx={{ my: 5, mx: "auto", maxWidth: 900 }}>
        <Card>
          <CardHeader
            title={
              <Typography variant="h5" align="center">
                Rocket Offer Listing
              </Typography>
            }
          />
          <CardContent>
            {/* Header */}
            <Typography variant="h6" align="center" sx={{ mb: 2 }}>
              47103 Timberlane St, Northville, MI 48167
            </Typography>
            <Box
              component="img"
              src="home1.jpg"
              alt="Home"
              sx={{ width: "100%", borderRadius: 1, mb: 2 }}
            />

            {/* Property Details and Features */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6">Property Overview</Typography>
                <ul>
                  <li>
                    <b>Address:</b> 47103 Timberlane St, Northville, MI 48167
                  </li>
                  <li>
                    <b>Listing Agent:</b> Frank Mastroianni
                  </li>
                  <li>
                    <b>Beds:</b> 4
                  </li>
                  <li>
                    <b>Baths:</b> 4 1/2
                  </li>
                  <li>
                    <b>Size:</b> 3,457 sqft
                  </li>
                  <li>
                    <b>Lot:</b> 1.46 Acres
                  </li>
                  <li>
                    <b>Built:</b> 1965
                  </li>
                  <li>
                    <b>Price per sqft:</b> $463
                  </li>
                  <li>
                    <b>Estimated Mortgage:</b> $10,841/mo
                  </li>
                  <li>
                    <b>HOA Fees:</b> None
                  </li>
                </ul>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="h6">Interior Details</Typography>
                <ul>
                  <li>
                    <b>Heating:</b> Forced Air, Natural Gas
                  </li>
                  <li>
                    <b>Cooling:</b> Central Air
                  </li>
                  <li>
                    <b>Appliances:</b> Dishwasher, Gas Range, Microwave
                  </li>
                  <li>
                    <b>Basement:</b> Full, Unfinished
                  </li>
                </ul>
              </Grid>
            </Grid>

<Grid container spacing={2}>
  {/* ARV Updates - Left Side */}
  <Grid item xs={12} md={4}>
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
    >
      <Typography variant="h6">ARV Updates</Typography>
      <FormControl fullWidth>
        <InputLabel id="reno-type-label">Renovation Type</InputLabel>
        <Select
          labelId="reno-type-label"
          value={renovationType}
          label="Renovation Type"
          onChange={(e) => setRenovationType(e.target.value)}
        >
          <MenuItem value="Kitchen Remodel">Kitchen Remodel</MenuItem>
          <MenuItem value="Bathroom Upgrade">Bathroom Upgrade</MenuItem>
          <MenuItem value="Roof Repair or Replacement">Roof Repair or Replacement</MenuItem>
          <MenuItem value="Exterior Painting or Siding Replacement">Exterior Painting or Siding Replacement</MenuItem>
          <MenuItem value="Interior Painting">Interior Painting</MenuItem>
          <MenuItem value="Flooring Upgrades">Flooring Upgrades</MenuItem>
          <MenuItem value="Window Replacement">Window Replacement</MenuItem>
          <MenuItem value="Door Replacement">Door Replacement</MenuItem>
          <MenuItem value="Basement Finishing or Remodeling">Basement Finishing or Remodeling</MenuItem>
          <MenuItem value="Deck or Patio Installation">Deck or Patio Installation</MenuItem>
          <MenuItem value="Attic Insulation">Attic Insulation</MenuItem>
          <MenuItem value="Garage Door Replacement">Garage Door Replacement</MenuItem>
          <MenuItem value="HVAC Upgrade">HVAC Upgrade</MenuItem>
          <MenuItem value="Landscaping and Yard Improvements">Landscaping and Yard Improvements</MenuItem>
          <MenuItem value="Fence Repair or Installation">Fence Repair or Installation</MenuItem>
          <MenuItem value="Driveway Resurfacing or Replacement">Driveway Resurfacing or Replacement</MenuItem>
          <MenuItem value="Laundry Room Remodel">Laundry Room Remodel</MenuItem>
          <MenuItem value="Lighting Upgrades">Lighting Upgrades</MenuItem>
          <MenuItem value="Waterproofing">Waterproofing</MenuItem>
          <MenuItem value="Smart Home Upgrades">Smart Home Upgrades</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Renovation Cost ($)"
        type="number"
        disabled={!renovationType}
        value={renovationCost}
        onChange={(e) => setRenovationCost(e.target.value)}
        fullWidth
      />

      <Button variant="contained" onClick={() => {
        console.log(`Added ${renovationType} costing $${renovationCost}`);
        // Optional: Save to array or update a chart
      }}>
        Add Renovation
      </Button>
    </Box>
  </Grid>

  {/* Existing Price Summary - Right Side */}
  <Grid item xs={12} md={8}>
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'blue',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1" fontWeight={500}>Price:</Typography>
        <Typography variant="body1" fontWeight={500}>$1,599,000</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1" fontWeight={500}>ARV:</Typography>
        <Typography variant="body1" fontWeight={500}>$220,000</Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1" fontWeight={500}>Margin:</Typography>
        <Typography variant="body1" fontWeight={500}>$210,000</Typography>
      </Box>
      <Stack spacing={1} sx={{ mt: 2 }}>
        <Button variant="contained" fullWidth>Buy it now</Button>
        <Button variant="outlined" fullWidth>Make an offer</Button>
      </Stack>
    </Box>
  </Grid>
</Grid>











          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
